var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.level!=null)?_c('div',{staticClass:"stars-container"},_vm._l((_vm.level),function(i){return _c('div',{key:i,staticClass:"star"},[_c('img',{attrs:{"src":require("@/assets/star.svg")}})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }